import React, { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import {
  Icon1CircleFill,
  Icon2CircleFill,
  Icon2Circle,
  Icon3CircleFill,
  Icon3Circle,
  ChevronRight,
} from "react-bootstrap-icons";
import classNames from "classnames";

interface IStepsInfoProps {
  step: number;
  stepNames: string[];
  className?: string;
}
export default function StepsInfo({
  step,
  stepNames,
  className,
}: IStepsInfoProps) {
  const IconStep2 = step < 2 ? Icon2Circle : Icon2CircleFill;
  const IconStep3 = step < 3 ? Icon3Circle : Icon3CircleFill;
  const [iconSize, setIconSize] = useState(window.innerWidth > 768 ? 26 : 20);

  useEffect(() => {
    const handleResize = () => {
      setIconSize(window.innerWidth > 768 ? 26 : 20);
    };
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const classes = (
    defaultStep: number,
    classesForDefault: string,
    classesForActive: string
  ) => (step >= defaultStep ? classesForActive : classesForDefault);

  return (
    <Col className={className || ""}>
      <ul className="d-flex list-unstyled justify-content-center justify-content-md-between align-items-center overflow-auto mb-0">
        <li className="d-flex align-items-center">
          <Icon1CircleFill
            className="text-primary me-md-2"
            style={{ fontSize: `${iconSize}px` }}
          />
          <span className="fw-bold d-none d-md-block">{stepNames[0]}</span>
        </li>
        <li>
          <ChevronRight
            className={classNames(
              "mx-3 mx-md-0",
              classes(2, "text-light", "text-dark")
            )}
          />
        </li>
        <li className="d-flex align-items-center">
          <IconStep2
            className={classNames(
              "me-md-2",
              classes(2, "text-gray", "text-primary")
            )}
            style={{ fontSize: `${iconSize}px` }}
          />
          <span
            className={classNames(
              "d-none d-md-block",
              classes(2, "text-gray", "text-dark fw-bold")
            )}
          >
            {stepNames[1]}
          </span>
        </li>
        <li>
          <ChevronRight
            className={classNames(
              "mx-3 mx-md-0",
              classes(3, "text-light", "text-dark")
            )}
          />
        </li>
        <li className="d-flex align-items-center">
          <IconStep3
            className={classNames(
              "me-md-2",
              classes(3, "text-gray", "text-primary")
            )}
            style={{ fontSize: `${iconSize}px` }}
          />
          <span
            className={classNames(
              "d-none d-md-block",
              classes(3, "text-gray", "text-dark fw-bold")
            )}
          >
            {stepNames[2]}
          </span>
        </li>
      </ul>
    </Col>
  );
}
